/**
 * API service for handling HTTP requests with configurable base URL
 */

// Get the API URL from environment variables or use the default
const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Determines if we should use a relative path or absolute URL
 * - In development with a proxy: use relative paths
 * - In production or with explicit API_URL: use absolute URLs
 */
function getUrl(endpoint: string): string {
  // If API_URL is empty or set to the same origin as the frontend, use relative path
  if (!API_URL || API_URL.includes(window.location.origin)) {
    return endpoint;
  }
  
  // Otherwise use the full URL
  return `${API_URL}${endpoint}`;
}

/**
 * Makes a POST request to the API
 * @param endpoint - The API endpoint
 * @param data - The data to send
 * @returns The API response
 */
async function post(endpoint: string, data: any) {
  const url = getUrl(endpoint);
  
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    // Include credentials to allow cookies to be sent
    credentials: 'include'
  });
  
  return response.json();
}

/**
 * Makes a GET request to the API
 * @param endpoint - The API endpoint
 * @returns The API response
 */
async function get(endpoint: string) {
  const url = getUrl(endpoint);
  
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    // Include credentials to allow cookies to be sent
    credentials: 'include'
  });
  
  return response.json();
}

export const api = {
  post,
  get,
}; 